import { Children, CSSProperties, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Versión estática de un carrusel para el HTML del servidor (hasta que el
 * carrusel real se monta tras hidratar). Mismas tarjetas y mismo ancho por
 * tarjeta que el estado inicial del carrusel, sin controles. Sirve para que
 * médicos, reseñas y tarjetas de tratamiento estén en el HTML que leen
 * Google y los asistentes de IA, y para que la página no salte al montarse.
 */
export default function StaticSlides({
  children,
  visibleSlides = 1,
  mobileVisibleSlides,
  className = '',
  isFullWidth = false,
}: {
  children: ReactNode;
  visibleSlides?: number;
  mobileVisibleSlides?: number;
  className?: string;
  isFullWidth?: boolean;
}) {
  const slides = Children.toArray(children).filter(Boolean);
  if (slides.length === 0) return null;

  const style = {
    '--hg-vs-d': visibleSlides,
    '--hg-vs-m': mobileVisibleSlides ?? visibleSlides,
  } as CSSProperties;

  return (
    <div className={twMerge(`relative w-full overflow-hidden ${className}`)}>
      {/* suppressHydrationWarning: algunos padres pasan un número de tarjetas
          distinto en servidor y cliente (isMobile); esta fila solo vive hasta
          que se monta el carrusel real. */}
      <ul
        suppressHydrationWarning
        className={`hg-static-slides flex ${isFullWidth ? 'hg-static-slides-full' : ''}`}
        style={style}
      >
        {slides.map((slide, index) => (
          <li key={`slide-${index}`}>
            {slide}
          </li>
        ))}
      </ul>
    </div>
  );
}
